require("packs/bookmarks");
import { setEvents } from "packs/bookmarks";
require("packs/user_profile_popup");
require("packs/link_tracker");
require("packs/comment_actions");
require("packs/comment_events");
require("packs/original_image");

document.addEventListener("DOMContentLoaded", function () {
  setEvents();
  document.addEventListener("click", function (event) {
    var element = event.target.closest(".post-reactions");
    if (!element) return;
  
    var url = element.dataset.linkReactions;
    var csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute("content");
  
    fetch(url, {
      method: "GET",
      headers: {
        "X-CSRF-Token": csrfToken,
        "X-Requested-With": "XMLHttpRequest",
        "Accept": "text/javascript",
      },
    })
      .then((response) => response.text())
      .then((data) => {
        eval(data);
      })
      .catch((error) => console.error("Error fetching reactions:", error));
  });
});
